module.exports = __webpack_public_path__ + "assets/semkan-auth.bd121e05.svg";